import { useEffect, useState } from "react";
import {
  _groupTechnologiesByService,
  connectFilesWithElement,
} from "@services/orders";
import { calcAvgRating } from "@services/review.helpers";
import { getMyOrdersApi, getMyUrgentOrdersApi, getOrderApi } from "./order.api";
import { _enrichElementInformation } from "./cad/cad.api";
import { servicesToTechnologies } from "./technology.helpers";
import { ORDER_STATUSES } from "../../constants/ORDER_STATUSES";

export function useMyUrgentOrders() {
  const [urgentOrders, setUrgentOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const orders = await getMyUrgentOrdersApi();

      setUrgentOrders(orders);
      setIsLoading(false);
    })();
  }, []);

  return [urgentOrders, isLoading];
}

export function useMyOrders(
  sort: Set<string>,
  filters: Record<string, string | number>
) {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    (async () => {
      const orders = await getMyOrdersApi(sort, filters);

      setOrders(orders);
    })();
  }, [sort, filters]);

  return [orders];
}

export function useOrder(orderId: string, refreshToken = 0) {
  const [order, setOrder] = useState();
  const [error, setError] = useState();

  useEffect(() => {
    if (!orderId) return;

    (async () => {
      const { isSuccess, data, error } = await getOrderApi(orderId);

      if (!isSuccess) {
        return setError(error);
      }

      const { order, offers, downloadHistory, downloadRequests } = data;

      if (order.status === ORDER_STATUSES.DRAFT) {
        order.elements = order.elements.map((element) => {
          element = _enrichElementInformation(element);

          return {
            ...element,
            technology_ids: servicesToTechnologies(element.services),
          };
        });
      }

      setOrder({
        ..._groupTechnologiesByService(connectFilesWithElement(order)),
        offers: offers.map((offer) => {
          const avgRating = calcAvgRating(offer.owner_company.reviews);

          return {
            ...offer,
            owner_company: { ...offer.owner_company, avgRating },
            isPartial: order.elements.length !== offer.offer_elements_count,
            anyMaterialsChanged: offer.elements.some(
              (el) => el.offer.material_id !== undefined
            ),
          };
        }),
        downloadHistory,
        downloadRequests,
      });
    })();
  }, [orderId, refreshToken]);

  return [order, error];
}
